export default __webpack_public_path__ + "static/media/filterBlip.6aa9be8b.svg";